import api from "api";
import { mediaApiBase } from "api/constants";
import { useQuery } from "react-query";
export const key = "getImages";

const useGetImages = (exercise_id?: number) => {
  return useQuery(key, () =>
    // @ts-ignore
    api.parse(`GET /exercises/images`, {
      root: mediaApiBase,
    })
  );
};

export default useGetImages;
